'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodashArrayFindIndex = require('lodash/array/findIndex');

var _lodashArrayFindIndex2 = _interopRequireDefault(_lodashArrayFindIndex);

var style = {
  display: 'block',
  width: '100%',
  boxSizing: 'border-box'
};

var optionType = _react.PropTypes.shape({
  label: _react.PropTypes.string.isRequired,
  value: _react.PropTypes.any
});

exports['default'] = _react2['default'].createClass({

  displayName: 'Demo.Controls.InputSelect',

  propTypes: {
    value: _react.PropTypes.any,
    options: _react.PropTypes.arrayOf(optionType.isRequired).isRequired,
    onChange: _react.PropTypes.func.isRequired
  },

  handleChange: function handleChange(e) {
    this.props.onChange(this.props.options[e.target.value].value);
  },

  renderOption: function renderOption(choice, index) {
    return _react2['default'].createElement(
      'option',
      { key: index, value: index },
      choice.label
    );
  },

  render: function render() {
    var _props = this.props;
    var options = _props.options;
    var value = _props.value;

    return _react2['default'].createElement(
      'select',
      {
        style: style,
        value: _lodashArrayFindIndex2['default'](options, function (x) {
          return x.value === value;
        }),
        onChange: this.handleChange
      },
      options.map(this.renderOption)
    );
  }

});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-demo/dist/Controls/InputSelect.js
// module id = 966
// module chunks = 0